import type React from 'react'
import { cn } from '../../../../shared/cn'

export const P3 = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <p
      className={cn('text-contentSecondary text-sm leading-6 xl:text-base xl:leading-7', className)}
    >
      {children}
    </p>
  )
}
